/**
 * In-memory authorization holder. Never writes to localStorage/sessionStorage/URL.
 */
export class AuthorizationMemory {
  private token: string | null = null;

  set(value: string | null | undefined): void {
    this.token = value && value.trim() ? value : null;
  }

  get(): string | null {
    return this.token;
  }

  clear(): void {
    this.token = null;
  }

  /** Safe for logs — never returns the raw token. */
  toLogSafe(): string {
    return this.token ? '[authorization:memory]' : '[authorization:none]';
  }
}
